import { render } from "./Item5.vue?vue&type=template&id=59a049a8&ts=true"
import script from "./Item5.vue?vue&type=script&lang=ts"
export * from "./Item5.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__